import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {KeycloakService} from 'keycloak-angular';
import {KeycloakProfile} from 'keycloak-js';
import {RouterStateSnapshot} from '@angular/router';
import {EUserType} from "@zikata-frontend/auth";
import {Observable} from "rxjs";
import IZikataClientProfile from '../../models/user-profile-model';
import { environment } from '../../../environments/environment';
import { ClientRequestDto, IKeycloakTokenResponse } from '../../models/citizenCreationRequest.model';
import { ResendOtpDto } from '../../models/common.model';


@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private http: HttpClient, private keycloak: KeycloakService) {
  }

  logout() {
    this.keycloak.logout();
  }

  isLoggedIn() {
    return this.keycloak.isLoggedIn();
  }

  userProfile(): Promise<KeycloakProfile> {
    return this.keycloak.loadUserProfile();
  }

  userRoles(): string[] {
    return this.keycloak.getUserRoles();
  }

  redirectToLogin(state: RouterStateSnapshot) {
    return this.keycloak.login({
      redirectUri: window.location.origin + state.url,
    });
  }

  getUserAccount(): Observable<IZikataClientProfile> {
    const url = environment.apiGatewayBaseUrl + '/user/current';
    return this.http.get<IZikataClientProfile>(url);
  }

  checkIfAccountExist(username: string, phoneNumber: string): Observable<any> {
    const url = environment.apiGatewayBaseUrl + '/user/check-if-exist';
    const userType = EUserType.CLIENT;
    return this.http.get(url, {params: {username, userType, phoneNumber}});
  }

  createClient(clientRequestDto: ClientRequestDto) {
    const url = environment.apiGatewayBaseUrl + '/user/register';
    return this.http.post<IKeycloakTokenResponse>(url, clientRequestDto);
  }

  resendAccountLink(resendOtpDto: ResendOtpDto) {
    const url = environment.apiGatewayBaseUrl + '/auth/v1/resend-activation-token';
    return this.http.post<IKeycloakTokenResponse>(url, resendOtpDto);
  }

  verifyPhoneNumber($event: string) {
    const url = environment.apiGatewayBaseUrl + '/user/verify/phone';
    return this.http.put(url, {},{params: {code: $event}});
  }

  resendVerificationCode() {
    const url = environment.apiGatewayBaseUrl + '/user/resend/phone-verification-code';
    return this.http.put(url, {});
  }
}
